import { SaveAmbassadorDto, SaveTravelAgentDto, SocialMediaMap } from "@hiptraveler/data-access/api";
import { isNull, omit, omitBy } from 'lodash';

import { ProfileState } from "@hiptraveler/data-access/profile";
import { getWindowRef, globalStateManagementStoreKey, cleanSocialHandle } from "@hiptraveler/common";

export function parseSaveAmbassadorPayload(value: SaveTravelAgentDto): SaveAmbassadorDto {

  const payload: SaveAmbassadorDto = omit(value, [
    'active', 'certId', 'certType', 'social', 'membership'
  ]) as any;

  payload.id = getWindowRef()[globalStateManagementStoreKey]
    .selectSnapshot(ProfileState.ambassador)?.id || payload.id;

  return {
    ...payload,
    trExp: value.trExp.desc,
    social: omitBy({
      website: value.social?.website,
      rss: value.social?.rss,

      tk: socialObject(cleanSocialHandle(value.social.tiktok, 'tiktok'), 'tiktok'),
      tw: socialObject(cleanSocialHandle(value.social.twitter, 'twitter'), 'twitter'),
      insta: socialObject(cleanSocialHandle(value.social.instagram, 'instagram'), 'instagram'),
      fb: socialObject(cleanSocialHandle(value.social.facebook, 'facebook'), 'facebook'),
      yt: socialObject(cleanSocialHandle(value.social.youtube, 'youtube'), 'youtube')
    }, isNull)
  };
}


/* -------------------------------------
   RETURN OBJECT FOR API
------------------------------------- */
function socialObject(handle: string | null, social: string): SocialMediaMap | null {
  if (!handle) return null;
  return { handle, id: social };
}
